module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fn1"
  }, [_c('span', [_vm._v("I was born on the prairie where the wind blew free")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_vm._v("and there was nothing to break the light of the sun.")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_vm._v("—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GERONIMO")]), _vm._v(", "), _c('i', [_vm._v("from his autobiography")])])]), _vm._v(" "), _c('p', {
    staticClass: "fn1"
  }, [_c('span', [_vm._v("This is a Godforsaken country and a")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_vm._v("Godforsaken people living in it!")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_vm._v("— "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CAPT. HENRY LAWTON")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_c('i', [_vm._v("Indian fighter, on entering Apache Territory")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "fn2"
  }, [_c('span', [_c('i', [_vm._v("from")]), _vm._v(" The Journal of Leonard Wood")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a26aab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter02.vue
// module id = 75
// module chunks = 0